module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "IBMi.1bcde794.svg";